export default __webpack_public_path__ + "static/media/rocket_anim_160.b5c6206d.png";